<div class="row centrado fullHeight" style="background-color: whitesmoke;    border: 0;">
  <div class="card width90 centrado" style="background-color: whitesmoke;    border: 0;">
    <div class="card-container" style="background-color: whitesmoke;    border: 0;">
      <div class="col-md-12 padding50">
        <img src="/assets/images/logo.png" class="imgLogoXS">
      </div><div class="padding50"></div>
      <div class="col-md-12">
        
        <p id="status" (click)="onLivenessCheckPressed()" class="">Inicializando...</p>
        <button id="liveness-button" disabled invisible (click)="onLivenessCheckPressed()" ></button>
      </div>
    </div>
  </div>
</div>
